import styles from './FJMobileHeader.module.less';
import HistoryIcon from '../../../assets/svg/mobile-history.svg?react';
import ProfileGrayIcon from '../../../assets/svg/profile-gray.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJStarIcon from '../../../assets/svg/star.svg?react';
import FJMobileStarIcon from '../../../assets/svg/mobile-star.svg?react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import FJMobileGenerateStatusContainer from '../FJMobileGenerateStatus/FJMobileGenerateStatusContainer';
import { useEffect, useRef, useState } from 'react';
import FJMobileRecognitionContainer from '../../FJMobileTextToImage/FJMobileRecognition/FJMobileRecognitionContainer';
import FJConfig from '../../../config/FJConfig';
import FJAppConstant from '../../../constants/FJAppConstant';
import creditsBase64 from '../../../assets/base64/credits';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';

const FJMobileHeader = props => {
    const {
        aiToolList = [],
        onHistoryClick,
        creditNumber,
        isLogin,
        getCredits,
        isShowGiftBtu = false,
        getGiftBtu,
    } = props;
    const [isShowAiTools, setIsShowAiTools] = useState(false);
    const headerBoxRef = useRef(null);
    const headPortraitRef = useRef(null);
    const renderAiTools = () => {
        if (!isShowAiTools) {
            return null;
        }
        return (
            <div
                onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    setIsShowAiTools(false);
                }}
                className={classNames(styles.full_screen_mask, isShowAiTools ? styles.fade_in : styles.fade_out)}
            >
                <div
                    className={classNames(styles.ai_menu_box, isShowAiTools ? styles.show : styles.hide)}
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                >
                    <div className={styles.ai_menu_title}>
                        {FJLocalStore._('ai-tools')}
                        <FJStarIcon />
                    </div>
                    <div className={styles.ai_menu_list}>
                        {aiToolList.map(item => (
                            <div
                                key={item.title}
                                className={styles.ai_menu_item}
                                onClick={() => (location.href = item.href)}
                            >
                                {<item.icon className={styles.ai_menu_icon} />}
                                {FJLocalStore._(item.title)}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };
    const _searchPortraitHeader = () => {
        const portraitHeader = document.querySelector('#loginButtonMobile');
        headPortraitRef.current && portraitHeader && headPortraitRef.current.appendChild(portraitHeader);
    };
    useEffect(() => {
        if (FJUtil.isLocalhost()) {
            return;
        }
        if (headPortraitRef.current && document.querySelector('#loginButtonMobile')) {
            _searchPortraitHeader();
        } else {
            setTimeout(_searchPortraitHeader, 100);
        }
    }, []);

    // 顶部生成状态加载
    const _renderRecognition = () => {
        if (FJConfig.appType === FJAppConstant.TEXT_TO_IMAGE) {
            return <FJMobileRecognitionContainer />;
        }
        return null;
    };
    return (
        <div className={styles.header_box} ref={headerBoxRef}>
            <div className={styles.left}>
                <div className={styles.head_portrait} ref={headPortraitRef}>
                    {(!isLogin || FJUtil.isLocalhost()) && <ProfileGrayIcon className={styles.profile_icon} />}
                </div>
                {isLogin && (
                    <div className={styles.credits_num} onClick={getCredits}>
                        <img src={creditsBase64} />
                        {Math.floor(creditNumber * 10) / 10}
                    </div>
                )}
            </div>
            <div className={styles.right}>
                <HistoryIcon className={styles.history} onClick={onHistoryClick} />
                {isShowGiftBtu && (
                    <FJButton
                        className={styles.gift_button}
                        type={FJButtonType.RED_BLUE_GRADIENT}
                        icon={<img className={styles.gift_button_icon} src={FJConfig.giftPng} />}
                        text={FJLocalStore._('20-off')}
                        textClassName={styles.gift_button_text}
                        onClick={getGiftBtu}
                    />
                )}
                <div
                    className={styles.ai_tools}
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                        setIsShowAiTools(true);
                    }}
                >
                    {isShowGiftBtu ? FJLocalStore._('ai-tool-mobile-ai') : FJLocalStore._('ai-tools')}
                    <FJMobileStarIcon className={styles.purple_star} />
                </div>
            </div>
            {renderAiTools()}
            <FJMobileGenerateStatusContainer />
            {_renderRecognition()}
        </div>
    );
};
FJMobileHeader.propTypes = {
    aiToolList: PropTypes.array,
    onHistoryClick: PropTypes.func,
    creditNumber: PropTypes.number,
    isLogin: PropTypes.bool,
    getCredits: PropTypes.func,
    isShowGiftBtu: PropTypes.bool,
    getGiftBtu: PropTypes.func,
};
export default FJMobileHeader;
